import $ from 'jquery';
import moment from 'moment';
import '../plugins/bootstrap-daterangepicker.js';

export default class DateRangePicker {
	constructor() { }

	static init() {
		// Date picker
		if ($('input.single-daterange').length) {
			$('input.single-daterange').each(function () {
				let position = $(this).data('position') || 'right';
				let picker = $(this).daterangepicker({
					"locale": {
						"format": "YYYY-MM-DD",
						"firstDay": 1
					},
					autoUpdateInput: false,
					autoApply: true,
					"singleDatePicker": true,
					opens: position
				});
			});

			$('input.single-daterange').on('apply.daterangepicker', function (ev, picker) {
				$(this).val(picker.startDate.format('YYYY-MM-DD'))
					.trigger("change");
			});
		}

		// Date range picker
		if ($('input.multi-daterange').length) {
			$('input.multi-daterange').daterangepicker({
				"locale": {
					"format": "YYYY-MM-DD",
					"firstDay": 1
				},
				autoUpdateInput: false,
				autoApply: true,
			});
			$('input.multi-daterange').on('apply.daterangepicker', function (ev, picker) {
				$(this).val(picker.startDate.format('YYYY-MM-DD') + ' - ' + picker.endDate.format('YYYY-MM-DD'))
					.trigger("change");
			});
		}
	}
}